// Query Domain Entity
import { QueryCommentEntity } from "./QueryCommentEntity";
import { QueryHistoryEntity } from "./QueryHistoryEntity";

export interface QueryEntity {
  queryId: number;
  parentQueryId: number | null;
  raisedBy: UserEntity;
  assignedTo: UserEntity | null;
  title: string;
  description: string | null;
  status: QueryStatus;
  priority: QueryPriority;
  source: QuerySource;
  sourceId: number | null;
  reviewRequired: boolean;
  createdAt: Date;
  updatedAt: Date;
  closedAt: Date | null;
  subQueries?: QueryEntity[];
  comments?: QueryCommentEntity[];
  history?: QueryHistoryEntity[];
  sourceDetails?: SourceDetailsEntity;
}

export enum QueryStatus {
  OPEN = "open",
  IN_PROGRESS = "in_progress",
  RESOLVED = "resolved",
  CLOSED = "closed",
}

export enum QueryPriority {
  LOW = "low",
  MEDIUM = "medium",
  HIGH = "high",
  URGENT = "urgent",
}

export enum QuerySource {
  GENERAL = "general",
  INVOICE = "invoice",
  BILL = "bill",
  TRANSACTION = "transaction",
  JOURNAL = "journal",
  CREDIT_NOTE = "credit_note",
}

export interface UserEntity {
  id: number;
  email: string;
  userName: string;
  role: string;
}

export interface SourceDetailsEntity {
  id: number;
  [key: string]: any; // Flexible structure for different source types
}

export interface CreateQueryParams {
  title: string;
  description?: string;
  priority: QueryPriority;
  source: QuerySource;
  sourceId?: number;
  assignedTo?: number;
  reviewRequired?: boolean;
}

export interface CreateSubQueryParams extends CreateQueryParams {
  parentQueryId: number;
}

export interface QueryFilters {
  source?: QuerySource | string;
  status?: QueryStatus | string;
  priority?: QueryPriority | string;
  assigned_to?: number;
  raised_by?: number;
  sort_by?: "created_at" | "updated_at";
  sort_order?: "asc" | "desc";
  search?: string;
}

export interface QueryPagination {
  limit: number;
  offset: number;
  hasMore: boolean;
  total: number;
}

export interface QuerySourcePayload {
  type: string;
  id: number | null;
}

export interface QueryListResult {
  queries: QueryEntity[];
  pagination: QueryPagination;
  source?: QuerySourcePayload;
}

